import React from 'react';
import styled from 'styled-components';
import { get, shuffle } from 'lodash';
import { graphql, StaticQuery } from 'gatsby';

import LinkCSS from '../Links/A.css'
import SCREENER_CTA_TYPES from '../analytics/screenerCtaTypes';
import getScreenerUrl from '../Links/getScreenerUrl';
import upsolveStats from '../../../content/onBuild/upsolveStats.json';

import ImageInContext from '../Media/ImageInContext';

const UpsolveFilersCount = (props) => (
  <StaticQuery
    query={graphql`
      query UpsolveFilersCountQuery {
        allContentfulFreshStartDiary(limit: 10) {
          edges {
            node {
              id
              filerImage {
                altText
                image {
                  file {
                    url
                  }
                  fluid(maxWidth: 56, maxHeight: 56) {
                    ...GatsbyContentfulFluid
                  }
                }
              }
            }
          }
        }
      }
    `}
    render={data => {
      const stories = shuffle(get(data, 'allContentfulFreshStartDiary.edges', []).map(s => s.node)).slice(0, 5);
      return (
        <UpsolveFilersCountWrapper>
          <div className="filers">
            {Array.prototype.map.call(stories, (story, index) => (
              <span key={index} className={`filer-${index}`}>
                <ImageInContext
                  className={`filer-${index}`}
                  alt={`${story.filerImage.altText} ${index + 1}`}
                  fluid={get(story, 'filerImage.image.fluid')}
                  src={get(story, 'filerImage.image.file.url')}
                />
              </span>
            ))}
          </div>
          <span className="user-prop-inline">
            <a
              aria-busy="false"
              href={getScreenerUrl({ cta: SCREENER_CTA_TYPES.UPSOLVE_FILERS_COUNT, contentGroup: props.contentGroup })}
            >
              <b>{upsolveStats.filings.total.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })} families</b> have filed bankruptcy using Upsolve. <u>Learn More</u>
            </a>.
          </span>
        </UpsolveFilersCountWrapper>
      );
    }}
  />
);

const UpsolveFilersCountWrapper = styled.span`
  &, div.filers {
    display: flex;
    align-items: center;
  }
  span[class^="filer-"] {
    height: 28px;
    width: 28px;
    border-radius: 20px;
    overflow: hidden;
    margin-right: -4px;
    img {
      width: 100%;
      min-height: 100%;
      min-width: 100%;
      transform: scale(1.1);
    }
  }
  .user-prop-inline {
    margin: 0 12px 0;
    font-size: 13px;
    a {
      color: ${props => props.theme.colors.gray[700]};
      & > u {
        ${LinkCSS}
      }
    }
  }
  @media(max-width: 45em) {
    flex-direction: column;
    align-items: flex-start;
    .user-prop-inline {
      margin: 8px 0;
    }
  }
`;

export default UpsolveFilersCount;
